import { candidateAPI } from "../api/candidate";
import { useLatestQuery } from "../api/useLatestQuery";
import { useWhoAmI } from "./useWhoAmI";

export function useResolvedDisplayName() {
  const { whoAmI, selectedVerifiedProfileInConcernForThisSession } = useWhoAmI();

  const { data: candidateDetails } = useLatestQuery(
    ["candidateAPI.getDetailsForCandidate"],
    () => candidateAPI.getDetailsForCandidate({}),
    { enabled: !!selectedVerifiedProfileInConcernForThisSession }
  );

  if (selectedVerifiedProfileInConcernForThisSession && candidateDetails?.fornavn) {
    return [candidateDetails.fornavn, candidateDetails.etternavn]
      .filter(Boolean)
      .join(" ");
  }
  if (!whoAmI) return "";
  if (whoAmI.usernameFromIdentityProvider === "firstname lastname") {
    return whoAmI.emailFromIdentityProvider;
  }

  return whoAmI.usernameFromIdentityProvider;
}
